module.exports = __webpack_public_path__ + "static/so-1-41ffe2751d68d83839bcf0215c9a6e6f.png";